export { multiply, add, subtract, divide } from './utils/math';
//# sourceMappingURL=math.js.map